(function(){
  const root=document.getElementById('glp1-lander'); if(!root) return;

  const videoModal=root.querySelector('[data-ts-video-modal]');
  const frame=root.querySelector('[data-ts-video-frame]');
  const videoOpen=root.querySelector('[data-ts-video-open]');
  const videoClose=root.querySelector('[data-ts-video-close]');
  const videoSrc='https://player.vimeo.com/video/961651102?autoplay=1&title=0&byline=0&portrait=0';

  const ingredientsModal=root.querySelector('[data-ts-ingredients-modal]');
  const ingredientsImg=root.querySelector('[data-ts-ingredients-img]');
  const ingredientsClose=root.querySelector('[data-ts-ingredients-close]');
  const ingredientsOpeners=root.querySelectorAll('[data-ts-ingredients-open]');
  const heroMainImage=root.querySelector('[data-ts-hero-main-image]');
  const heroThumbs=root.querySelectorAll('[data-ts-hero-thumb]');
  const stickyCta=root.querySelector('[data-ts-sticky-cta]');
  const faqSection=root.querySelector('.ts-faq');

  function lockPage(){ document.documentElement.style.overflow='hidden'; }
  function unlockPage(){ document.documentElement.style.overflow=''; }

  function showVideo(){
    if(!videoModal||!frame) return;
    frame.src=videoSrc;
    videoModal.classList.add('is-open');
    videoModal.removeAttribute('aria-hidden');
    lockPage();
  }
  function hideVideo(){
    if(!videoModal||!frame) return;
    frame.src='';
    videoModal.classList.remove('is-open');
    videoModal.setAttribute('aria-hidden','true');
    if(!ingredientsModal?.classList.contains('is-open')) unlockPage();
  }

  function showIngredients(button){
    if(!ingredientsModal||!ingredientsImg||!button) return;
    ingredientsImg.src=button.getAttribute('data-ts-ingredients-src')||'';
    ingredientsImg.alt=button.getAttribute('data-ts-ingredients-alt')||'Supplement Facts';
    ingredientsModal.classList.add('is-open');
    ingredientsModal.removeAttribute('aria-hidden');
    lockPage();
  }
  function hideIngredients(){
    if(!ingredientsModal||!ingredientsImg) return;
    ingredientsModal.classList.remove('is-open');
    ingredientsModal.setAttribute('aria-hidden','true');
    ingredientsImg.src='';
    if(!videoModal?.classList.contains('is-open')) unlockPage();
  }

  videoOpen&&videoOpen.addEventListener('click',showVideo);
  videoClose&&videoClose.addEventListener('click',hideVideo);
  videoModal&&videoModal.addEventListener('click',e=>{if(e.target===videoModal) hideVideo();});

  ingredientsOpeners.forEach(button=>button.addEventListener('click',()=>showIngredients(button)));
  ingredientsClose&&ingredientsClose.addEventListener('click',hideIngredients);
  ingredientsModal&&ingredientsModal.addEventListener('click',e=>{if(e.target===ingredientsModal) hideIngredients();});

  heroThumbs.forEach(button=>button.addEventListener('click',()=>{
    if(!heroMainImage) return;
    const src=button.getAttribute('data-ts-hero-thumb-src');
    const alt=button.getAttribute('data-ts-hero-thumb-alt');
    if(src) heroMainImage.src=src;
    if(alt) heroMainImage.alt=alt;
    heroThumbs.forEach(thumb=>thumb.closest('.thumbs-list-item')?.classList.remove('is-active'));
    button.closest('.thumbs-list-item')?.classList.add('is-active');
  }));

  function updateStickyCta(){
    if(!stickyCta||!faqSection) return;
    const faqBottom=faqSection.getBoundingClientRect().bottom+window.scrollY;
    const viewportBottom=window.scrollY+window.innerHeight;
    stickyCta.classList.toggle('is-hidden',viewportBottom>=faqBottom);
  }

  updateStickyCta();
  window.addEventListener('scroll',updateStickyCta,{passive:true});
  window.addEventListener('resize',updateStickyCta);

  document.addEventListener('keydown',e=>{if(e.key==='Escape'){hideVideo();hideIngredients();}});
})();
